/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0c17.597 0 32 14.405 32 32v448c0 17.592-14.402 32-32 32H32c-17.593 0-32-14.408-32-32V32C0 14.405 14.407 0 32 0zM315.535 131.094c-34.865 0-63.14 28.276-63.14 63.157 0 4.948.565 9.774 1.64 14.402-52.478-2.632-99.001-27.794-130.15-66-5.446 9.33-8.56 20.179-8.56 31.757 0 21.91 11.147 41.24 28.087 52.572a62.873 62.873 0 01-28.58-7.907v.792c0 30.609 21.767 56.124 50.64 61.927a62.983 62.983 0 01-16.632 2.213c-4.062 0-8.033-.39-11.876-1.129 8.032 25.096 31.349 43.353 58.982 43.855-21.623 16.944-48.836 27.046-78.418 27.046-5.101 0-10.128-.302-15.083-.885 27.962 17.92 61.15 28.387 96.817 28.387 116.128 0 179.645-96.253 179.645-179.706 0-2.733-.055-5.457-.18-8.171 12.348-8.91 23.04-20.032 31.492-32.686a125.624 125.624 0 01-36.266 9.93c13.041-7.817 23.06-20.187 27.778-34.927a126.634 126.634 0 01-40.092 15.323c-11.513-12.28-27.943-19.95-46.104-19.95z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconTwitter = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconTwitter.defaultProps = {
  theme,
};
IconTwitter.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconTwitter.displayName = 'IconTwitter';
export { IconTwitter };
